import { Fragment } from "react";
import { CSS } from "src/_utils/styles";
import { Breadcrumbs } from "src/AbstractElements";
import ListContain from "../Component/Ecommerce/List";
import { useEBSSS } from "./context/EBSSSContext/useEBSSS";
import EBSSSChatContainer from "./atoms/EBSSSChatContainer";
import { RenderReactChatInstance } from "src/assets/chat/chat";
import { EBSSSChatModule } from "src/assets/chat/core";
import { ReduxDataKey } from "./store/store";
import { useSelector } from "react-redux";
import { Session } from "./store/authSlice";

const TablePage = ({ children, title, description, breads }) => {
  const sessionNow: Session = useSelector((state) => state[ReduxDataKey.AUTH]);
  const { loaded, hasChats, chatDataPreview, chatDataSetter, setHasChats, setChatDataPreview, setChatDataSetter } = useEBSSS();

  console.log("Has chats Page element: ", hasChats);

  return (
    <Fragment>
      {sessionNow?.user["from_gamify"] ? <></> : <Breadcrumbs breads={breads} title={breads[breads.length - 1].name} />}
      <ListContain title={title} description={description}>
        {loaded ? (
          children
        ) : (
          <div className="w-100 justify-center justify-content-center d-flex" style={CSS({ height: "50vh" })}>
            <div className="loader d-flex align-center justify-center m-auto text-center">
              <div className="loader-bar"></div>
              <div className="loader-bar"></div>
              <div className="loader-bar"></div>
              <div className="loader-bar"></div>
              <div className="loader-bar"></div>
              <div className="loader-ball"></div>
            </div>
          </div>
        )}

        {hasChats?.length > 0 ? (
          hasChats?.map((ch) => {
            console.log("Guid config: ", ch);
            if (ch.type !== "pop") return <></>;
            if (localStorage.getItem("NOT_FOUND_CHAT_" + ch.guid) === "true") return <></>;
            //@ts-ignore
            new EBSSSChatModule(ch).init();
            return (
              <EBSSSChatContainer chatDataSetter={chatDataSetter} guidData={ch} chatDataPreview={chatDataPreview}>
                <RenderReactChatInstance
                  {...(ch as any)}
                  sufixGUID={ch.guid}
                  chatDataSetter={chatDataSetter}
                  setChatDataSetter={setChatDataSetter}
                  setChatDataPreview={setChatDataPreview}
                />
              </EBSSSChatContainer>
            );
          })
        ) : (
          <></>
        )}
      </ListContain>
    </Fragment>
  );
};
export default TablePage;
